import { Component, OnInit} from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  constructor( ) { }

  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/a2-components/sidebar/sidebar.component.ts